import React from 'react';
import { Tabs, Tab, Typography, Box, Paper, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UserDeposits from './Deposits/Deposits.component';
import UserWithdraws from './Withdraws/Withdraws.component';




// --- THEMED TAB PANEL COMPONENT ---

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${ index }`}
            aria-labelledby={`tab-${ index }`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `tab-${ index }`,
        'aria-controls': `tabpanel-${ index }`,
    };
}

export default function UserConnectionsTabs({ userId }) {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const tabLabels = [t('user.deposits'), t('user.withdrawals')];

    return (
        <Paper sx={{ width: '100%' }}>
            <Tabs
                value={value}
                onChange={handleChange}
                textColor="inherit"
                indicatorColor="primary"
                centered
            >
                {tabLabels.map((label, index) => (
                    <Tab
                        key={index}
                        label={label}
                        {...a11yProps(index)}
                        sx={{
                            color: value === index ? 'white' : 'gray',
                            '&.Mui-selected': {
                                color: 'white',
                            }
                        }}
                    />
                ))}
            </Tabs>

            <TabPanel value={value} index={0}>
                <UserDeposits userId={userId} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                {/* <UserHoldings userId={userId} /> */}
                <UserWithdraws userId={userId} />
            </TabPanel>


            <Alert severity="info" sx={{ margin: 2 }}>
                <Typography variant="body2">
                    {t('user.connectionDescription')}
                </Typography>
                <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
                    {t('explorationInstructions')}
                </Typography>
            </Alert>

        </Paper>
    );
}
